<template>
  <MCol :key="item.id" :style="{ width: cardWidth }" class="flex">
    <div class="asset-item flex-1 min-w-0">
      <AssetTypeIcon
        v-if="moduleName === $constants.CMDB"
        :ci-type-id="item.ciTypeId"
        size="lg"
        class="pb-3"
        style="color: var(--primary-alt)"
      />
      <AssetTypeIcon
        v-else
        :asset-type-id="item.assetTypeId"
        size="lg"
        class="pb-3"
        style="color: var(--primary-alt)"
      />
      <div>
        {{ moduleName === $constants.CMDB ? item.ciName : item.name }}
      </div>
      <div class="w-full">
        <MTooltip>
          <template v-slot:trigger>
            <div class="text-ellipsis text-center">
              {{
                moduleName === $constants.CMDB
                  ? item.ciDisplayName
                  : item.displayName
              }}
            </div>
          </template>
          {{
            moduleName === $constants.CMDB
              ? item.ciDisplayName
              : item.displayName
          }}
        </MTooltip>
      </div>
      <div class="border-placehoder"></div>
    </div>
  </MCol>
</template>

<script>
import AssetTypeIcon from '@components/custom-icon/asset-type-icon.vue'
export default {
  name: 'MyAssetItem',
  components: { AssetTypeIcon },
  props: {
    item: { type: Object, required: true },
    cardWidth: { type: String, default: '33%' },
    moduleName: {
      type: String,
      default() {
        return this.$constants.ASSET
      },
    },
  },
}
</script>

<style lang="less" scoped>
.asset-item {
  @apply rounded justify-center items-center p-4 flex flex-col;

  position: relative;
  min-height: 6.221rem;
  font-size: 0.769rem;
  background: var(--neutral-lightest);

  & .border-placehoder {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3.08px;
    background: #1780c3;
  }
}
</style>
